// This component is used to render a custom template for our tooltip directive.
// If you pass the directive a template, it will render it inside this component.
// This allows us to make use of Angular's template rendering capabilities to render the tooltip content.

import {
  Component,
  ElementRef,
  TemplateRef,
  ViewChild,
  ChangeDetectionStrategy,
} from '@angular/core';
import { NgTemplateOutlet } from '@angular/common';

/**
 * @deprecated Do not add new instances of this component. Use PrimeNG's 'pTooltip' directive instead.
 */
@Component({
  selector: 'ag1-tooltip-container',
  templateUrl: './ag1-tooltip-container.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [NgTemplateOutlet],
})
export class Ag1TooltipContainerComponent {
  template: TemplateRef<any>;
  @ViewChild('content', { static: true }) content: ElementRef;
}
